import { CALENDLY_URL } from "../config/marketing";
import { SITE, absoluteUrl, defaultOgImageUrl } from "../config/site";
import { SITE_AUDIENCES, SITE_FAQ, SITE_OUTCOMES } from "../content/siteContent";

type JsonLd = Record<string, unknown>;

function organizationSchema(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${absoluteUrl("/")}#organization`,
    name: SITE.legalName,
    url: absoluteUrl("/"),
    logo: defaultOgImageUrl(),
    description: SITE.description,
    email: SITE.contactEmail,
    sameAs: [],
  };
}

function webSiteSchema(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${absoluteUrl("/")}#website`,
    name: SITE.name,
    url: absoluteUrl("/"),
    description: SITE.description,
    inLanguage: SITE.language,
    publisher: { "@id": `${absoluteUrl("/")}#organization` },
  };
}

function softwareApplicationSchema(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "@id": `${absoluteUrl("/")}#software`,
    name: SITE.name,
    applicationCategory: SITE.applicationCategory,
    operatingSystem: SITE.operatingSystem,
    description: SITE.description,
    url: absoluteUrl("/"),
    image: defaultOgImageUrl(),
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
      description: "Early partner program — limited slots with founder-led onboarding",
      url: CALENDLY_URL,
    },
    featureList: SITE_OUTCOMES,
    audience: {
      "@type": "Audience",
      audienceType: SITE_AUDIENCES.join("; "),
    },
    provider: { "@id": `${absoluteUrl("/")}#organization` },
  };
}

function faqPageSchema(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "@id": `${absoluteUrl("/")}#faq`,
    mainEntity: SITE_FAQ.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}

/** JSON-LD graphs for public indexable pages (landing). */
export function buildLandingStructuredData(): JsonLd[] {
  return [organizationSchema(), webSiteSchema(), softwareApplicationSchema(), faqPageSchema()];
}
